import React from 'react';
import './FontComparison.css';

const FontComparison = () => {
    // Sample text similar to what might be in your main banners
    // You can replace these with your actual banner text if preferred
    const mainBannerText = "نادي سيكس يارد لكرة القدم";
    const mainBannerWithSpan = <>نادي <span className="highlight">سيكس يارد</span> لكرة القدم</>;
    const subBannerText = "انضم إلينا اليوم واستمتع بتجربة كرة قدم لا مثيل لها في قطر";

    return (
        <div className="font-comparison-container">
            <h2 className="font-comparison-title">Font Comparison</h2>
            <p className="font-comparison-instructions">
                Visit this page to compare how different Arabic fonts look with your hero section text.
                Scroll through to see each font option.
            </p>
            
            <div className="font-option">
                <h3 className="font-name">IBM Plex Sans Arabic</h3>
                <p className="font-description">
                    Clean, professional, and highly legible with a contemporary feel that works well for sports brands
                </p>
                <div className="font-demo ibm-plex">
                    <div className="main-banner">
                        <h1>{mainBannerWithSpan}</h1>
                    </div>
                    <div className="sub-banner">
                        <h3>{subBannerText}</h3>
                    </div>
                </div>
            </div>

            <div className="font-option">
                <h3 className="font-name">Tajawal</h3>
                <p className="font-description">
                    A modern sans-serif Arabic font with excellent readability that's particularly good for headings and navigation elements
                </p>
                <div className="font-demo tajawal">
                    <div className="main-banner">
                        <h1>{mainBannerWithSpan}</h1>
                    </div>
                    <div className="sub-banner">
                        <h3>{subBannerText}</h3>
                    </div>
                </div>
            </div>

            <div className="font-option">
                <h3 className="font-name">Cairo</h3>
                <p className="font-description">
                    A versatile font designed specifically for both Arabic and Latin scripts with a sporty, dynamic character
                </p>
                <div className="font-demo cairo">
                    <div className="main-banner">
                        <h1>{mainBannerWithSpan}</h1>
                    </div>
                    <div className="sub-banner">
                        <h3>{subBannerText}</h3>
                    </div>
                </div>
            </div>

            <div className="font-option">
                <h3 className="font-name">Almarai</h3>
                <p className="font-description">
                    A professional-looking font with clean lines that would convey reliability and modernity
                </p>
                <div className="font-demo almarai">
                    <div className="main-banner">
                        <h1>{mainBannerWithSpan}</h1>
                    </div>
                    <div className="sub-banner">
                        <h3>{subBannerText}</h3>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FontComparison; 